import { getUnifiedAuthConfigUrl } from './Api';
import { AuthenticateError } from './LowLevelUnifiedAuth';
import { hubletApi, resolveApi } from 'hub-http/middlewares/core';
export function fetchAuthConfigForUnifiedAuth(http, portalId, authenticatorId, appName, oAuthScope, mcp, appId) {
  return async () => {
    const authFlow = await http.get(getUnifiedAuthConfigUrl(authenticatorId), {
      query: {
        portalId,
        appName
      }
    });
    return {
      appName,
      appIcon: '',
      oAuthScope,
      mcp,
      authFlow,
      appId,
      makeAuthorizeUrlDescriptor() {
        return {
          hostname: resolveApi(hubletApi('app', 'hubspot')),
          path: `/api/unified-auth/v1/authenticators/${authenticatorId}/authorize`
        };
      },
      getAuthorizeUrl(query) {
        return http.get(`unified-auth/v1/authenticators/${authenticatorId}/authorize-url`, {
          query: Object.assign({
            portalId
          }, query)
        });
      },
      finishAuthFlow(payload) {
        return http.post(`unified-auth/v1/authenticators/${authenticatorId}/secret`, {
          data: payload,
          query: {
            portalId
          }
        }).then(finishPayload => {
          if (typeof finishPayload === 'object' && 'status' in finishPayload && finishPayload.status === 'error') {
            throw new AuthenticateError(finishPayload.message, finishPayload.upstreamErrorMessage);
          } else {
            return finishPayload;
          }
        });
      }
    };
  };
}